// extracted by mini-css-extract-plugin
export default {"error":"ErrorHandler_error__wy1r6"};